/* oxlint-disable-next-line no-restricted-imports -- use v4 so that trace ids look distinct */
import { v4 } from "uuid";

export function createTraceId(): string {
  return v4();
}

const MAX_TRACE_ID_LENGTH = 128;

/**
 * Deliberately wider than the uuid `createTraceId` produces, since services
 * propagate trace ids to each other and some synthesize their own. `/` and `*`
 * are excluded so that a trace id can never contain a SQL comment delimiter.
 */
const TRACE_ID_PATTERN = /^[\w.:-]+$/;

/**
 * Whether a trace id is safe to adopt from an untrusted source. Trace ids are
 * echoed back in response headers and embedded in log records and SQL query
 * comments, so a value arriving over the wire is only trusted when it looks
 * like one we could have produced ourselves.
 */
export function isValidTraceId(traceId: string): boolean {
  return (
    traceId.length <= MAX_TRACE_ID_LENGTH && TRACE_ID_PATTERN.test(traceId)
  );
}
